module.exports = __webpack_public_path__ + "static/media/image-4.faf808a9.jpeg";